export interface ICampPosition {
	0: number
	1: number
}

const _positions: ICampPosition[] = [
	[480, 445],
	[280, 435],
	[133, 482],
	[700, 470],
	[380, 490],
	[580, 400],
	[790, 427],
	[30, 420],
	[540, 484],
	[210, 410],
	[620, 460],
	[50, 490],
	[760, 490],
	[350, 450],
	[460, 495],
	[230, 490],
	[120, 430],
	[420, 420],
	[640, 480],
	[670, 430],
	[305, 460],
]

export default function (index: number) {
	if (_positions.length <= index) {
		while (_positions.length <= index) {
			_positions.push([100 + Math.random() * 700, 430 + Math.random() * 60])
		}
	}
	return _positions[index]
}
